module.exports = __webpack_public_path__ + "static/media/flow-jump-mobile-pl.ad10ca20.png";